import { Controller } from "@hotwired/stimulus"

// Nested form for team performance goals (metas). Add/remove rows + quick
// presets that fill ends_on from starts_on (mensal/trimestral/semestral/anual).
export default class extends Controller {
  static targets = ["list", "template", "empty"]

  add(event) {
    event.preventDefault()
    const markup = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, Date.now().toString())
    this.listTarget.insertAdjacentHTML("beforeend", markup)
    this.toggleEmpty()
  }

  remove(event) {
    event.preventDefault()
    const row = event.target.closest("[data-team-goals-row]")
    if (!row) return

    const destroyField = row.querySelector("input[name*='_destroy']")
    if (destroyField) {
      destroyField.value = "1"
      row.classList.add("hidden")
    } else {
      row.remove()
    }
    this.toggleEmpty()
  }

  // Preset button: end = start + N months - 1 day. Defaults start to the first
  // day of the current month when empty.
  preset(event) {
    event.preventDefault()
    const months = parseInt(event.currentTarget.dataset.months, 10)
    const row = event.currentTarget.closest("[data-team-goals-row]")
    if (!row) return

    const startInput = row.querySelector("[data-goal-start]")
    const endInput = row.querySelector("[data-goal-end]")
    if (!startInput || !endInput) return

    let start
    if (startInput.value) {
      start = new Date(startInput.value + "T00:00:00")
    } else {
      const now = new Date()
      start = new Date(now.getFullYear(), now.getMonth(), 1)
      startInput.value = this.format(start)
    }

    const end = new Date(start.getFullYear(), start.getMonth() + months, start.getDate())
    end.setDate(end.getDate() - 1)
    endInput.value = this.format(end)
  }

  toggleEmpty() {
    if (!this.hasEmptyTarget) return
    const visibleRows = this.listTarget.querySelectorAll("[data-team-goals-row]:not(.hidden)")
    this.emptyTarget.classList.toggle("hidden", visibleRows.length > 0)
  }

  format(date) {
    const y = date.getFullYear()
    const m = String(date.getMonth() + 1).padStart(2, "0")
    const d = String(date.getDate()).padStart(2, "0")
    return `${y}-${m}-${d}`
  }
}
